module.exports = __webpack_public_path__ + "img/thumb-leavingearth.090bf377.png";